import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import keepAlive from './modules/keepAlive'
import getters from './getters'
import settings from './modules/settings'
import tagsView from './modules/tagsView'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    keepAlive,
      tagsView,
      settings
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js